import { Inject, Options, Vue } from "vue-property-decorator";
import { AuthorizedUser } from '@/trust-atcs-app/models/authorized-user';
import store from '../../store';
import { TrustAPI } from "@/shared/modules/trust-api";
import { RouteN } from "@/trust-atcs-app/constants/router-name";
import { EventEmitter } from "events";

@Options({})
export default class EEInactive extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private signOut() {
    this.$router.push({ name: RouteN.ATCS.LogoutPage.n });
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get userAccount(): AuthorizedUser {
    return store.getters.getUserAccount;
  }  
}

